"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabButton = exports.FabContent = exports.ButtonContent = exports.LoaderContainer = exports.buttonTypeCss = exports.smallCss = exports.extraLargeCss = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var material_1 = require("@mui/material");
var colors_1 = require("../ThemeProvider/colors");
exports.extraLargeCss = {
    height: '54px',
    padding: '0 32px 0 32px',
    minWidth: '170px',
    borderRadius: '3px',
};
exports.smallCss = {
    minHeight: '24px',
    padding: '0 6px',
    borderRadius: '3px',
};
exports.buttonTypeCss = {
    danger: {
        color: colors_1.tannerSemantic.error.color,
        '&:hover, &:focus-visible': {
            background: colors_1.tannerSemantic.error.background,
            color: colors_1.tannerSemantic.error.color,
        },
        '&:disabled': {
            color: colors_1.tannerSemantic.error.color,
        },
        '&:active': {
            background: '#f6c8c7',
        },
    },
    secondary: {
        '&:hover': {
            background: colors_1.tannerGray[100],
            color: colors_1.tannerGray[900],
        },
        '&:disabled': {
            color: colors_1.tannerGray[900],
        },
        '&:active': {
            background: colors_1.tannerGray[200],
        },
    },
};
exports.LoaderContainer = styled_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n"], ["\n  position: absolute;\n"])));
exports.ButtonContent = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inherit;\n  visibility: ", ";\n  align-items: center;\n"], ["\n  display: inherit;\n  visibility: ", ";\n  align-items: center;\n"])), function (props) { return (props.loading ? 'hidden' : 'inherit'); });
exports.FabContent = (0, styled_1.default)(exports.ButtonContent)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
exports.FabButton = (0, styled_1.default)(material_1.Fab)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  &.Mui-disabled {\n    color: ", ";\n    span .MuiBox-root {\n      color: ", ";\n    }\n  }\n"], ["\n  color: ", ";\n  &.Mui-disabled {\n    color: ", ";\n    span .MuiBox-root {\n      color: ", ";\n    }\n  }\n"])), function (props) { return props.themeColor; }, function (props) { return (0, material_1.alpha)(props.themeColor, 0.6); }, function (props) { return props.themeColor; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map